import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { ButtonBase } from 'components';
import { abreviaturas, masterEvents, masterMessages } from 'constantes';
import { ReactComponent as HeinsohnLogo } from 'assets/images/logoHeinsohn.svg';
import { ReactComponent as ErrorImage } from 'assets/images/errorImage.svg';
import { AnalyticsAmplitud } from 'utils/Analytics-Amplitud';

// Estilos de la pagina
const useStyles = makeStyles(() => ({
    containerLogo: {
        marginTop: -30,
        padding: 70,
    },
    logo: {
        marginTop: 5,
        width: '35%',
        height: '1%',
    },
    titleAcceso: {
        color: '#C00333',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
    },
    titleDeny: {
        color: '#3E3E3C',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
    },
    messageEmail: {
        color: '#3E3E3C',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
    },
    containerMessage: {
        padding: 70,
    },
    errorImage: {
        width: '100%',
        height: '50%',
    },
    imageContainer: {
        marginTop: '9%',
    },
}));

function Page404() {
    // Mensajes mostrar
    const { auth: { page404 }, buttons } = masterMessages;
    const classes = useStyles();
    const history = useHistory();
    // Conexión con analiticas al no existir el recurso
    AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_NO_EXISTE_RECURSO);

    /**
     * @name onBack
     * @desc Funcionalidad del boton volver para llevar de nuevo a loguin u OTP
     */
    const onBack = () => {
        history.push('/apiv1/sign-in');
    };

    return (
      <div className="containerWrapper">
        <Grid container spacing={2}>
          <Grid item sm={12} md={6} xl={6}>
            <div className={classes.containerLogo}>
              <Typography variant="h6" color="inherit">
                <HeinsohnLogo className={classes.logo} />
              </Typography>
            </div>
            <div className={classes.containerMessage}>
              <h1 className={classes.titleAcceso}>{page404.title}</h1>
              <h1 className={classes.titleDeny}>{page404.subtitle}</h1>
              <p>
                <span className={classes.messageEmail}>{page404.messageError1}</span>
                {' '}
                {page404.messageError2}
              </p>
              <Grid container style={{ marginBottom: 15 }}>
                <Grid item xs={6} md={6}>
                  <ButtonBase
                    caption={buttons.back}
                    colorBase={abreviaturas.DEFAULT_RED_COLOR}
                    onClickEvent={onBack}
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item sm={12} md={6} xl={6}>
            <div className={classes.imageContainer}>
              <ErrorImage className={classes.errorImage} />
            </div>
          </Grid>
        </Grid>
      </div>
    );
}

export default Page404;
